// extracted by mini-css-extract-plugin
export default {"defaultLink":"footlink_defaultLink__Podkp","active":"footlink_active__+Kpwt"};